/**
 * HUB-8335: HubOps POST /api/connections/search (replaces legacy connection list TMS proxies).
 */
import apiUrl from '../constants';

export const CONNECTION_SEARCH_PURPOSE = {
  SCHEDULE: 'schedule',
  BAGGING: 'bagging',
  LOCAL_TP: 'localTP',
  LOCAL_LINEHAUL: 'localLinehaul'
};

function assignNumericFilter(body, key, value) {
  if (value === undefined || value === null || value === '') {
    return;
  }
  const parsed = Number(value);
  body[key] = Number.isNaN(parsed) ? value : parsed;
}

/**
 * @param {string} purpose - schedule | bagging | localTP | localLinehaul
 * @param {object} filters - type, source, destination, connectionid
 */
export function buildConnectionsSearchPayload(purpose, filters = {}) {
  const body = { purpose };
  assignNumericFilter(body, 'type', filters.type);
  assignNumericFilter(body, 'source', filters.source);
  assignNumericFilter(body, 'destination', filters.destination);
  assignNumericFilter(body, 'connectionid', filters.connectionid);
  return body;
}

export function getConnectionsSearchUrl() {
  return apiUrl.api_url_hubops + 'connections/search';
}



// WEBPACK FOOTER //
// ./src/utils/connectionsSearchApi.js